import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

const basicSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  amount: Yup.number().required("Amount is required"),
  status: Yup.string().required("Status is required"),

});

const AddInitialPrice = ({ showModal, hideModal, getInitialPrices }) => {
  const history = useNavigate();
   

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    addInitialPrice(values);
  };


  const { values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit, submitForm } = useFormik({
      initialValues: {
        name: "",
        amount: '',
        status: '',


      },
      validationSchema: basicSchema,
      onSubmit
    })


  const notifySuccess = () => toast.success('VehicleType Added.', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const notifyError = () => toast.error('Something went wrong ...', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const addInitialPrice = async (e) => {

    try {

      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }


      const response = await axios.post("/initialPrice", bodyFormData);
      history("/vehicleTypes");
      hideModal();
      getInitialPrices();
      notifySuccess();
      console.log(response.status)
    } catch (error) {
      console.log(error.response)
      if (error.response) {

        notifyError();
      }
    }
  };


  return (


    <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">

      <Modal
       style={{marginTop: "60px"}} 
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
      >

        <Modal.Header closeButton>
          <Modal.Title>Add Initial Price</Modal.Title>
        </Modal.Header>
        <Modal.Body   >



          <div class="row" >
            <div class="col-md-12">
              <div class="card card-primary">


                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName"> Name</label>
                    <input
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      // id="inputName"
                      className={errors.name && touched.name ? "form-control input-error" : "form-control "}

                    />
                    {errors.name && touched.name && <p className="error">{errors.name}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Amount</label>
                    <input
                      type="number"
                      name="amount"
                      value={values.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.amount && touched.amount ? "form-control input-error" : "form-control "}

                    />
                    {errors.amount && touched.amount && <p className="error">{errors.amount}</p>}

                  </div>


                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.status && touched.status ? "form-control input-error" : "form-control "}

                    >
                      <option selected>
                        Select Status
                      </option>

                      <option key={"Active"} value={"Active"}>
                        {"Active"}
                      </option>
                      <option key={"Inactive"} value={"Inactive"}>
                        {"Inactive"}
                      </option>

                    </select>
                    {errors.status && touched.status && <p className="error">{errors.status}</p>}

                  </div>

                </div>
              </div>
            </div>

          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
            Submit
          </button>

        </Modal.Footer>

      </Modal>
    </form>

  );
};

export default AddInitialPrice;
